import { styled } from 'baseui';
import { version } from '../../version';

export const FooterContainer = styled('div', ({ $theme }) => ({
  width: '100%',
  textAlign: 'center',
  paddingTop: '32px',
  paddingBottom: '32px',
  opacity: 0.7,
  color: $theme.colors.contentPrimary,
}));

export const FooterTitle = styled('h4', {
  margin: '0 0 8px 0',
  fontSize: '16px',
});

export const FooterCopyright = styled('p', {
  margin: 0,
  fontSize: '12px',
});

const PageFooter = () => {
  return (
    <FooterContainer>
      <FooterTitle>Blind Pace v{version}</FooterTitle>
      <FooterCopyright>©2026 Necron</FooterCopyright>
    </FooterContainer>
  );
};

export default PageFooter;
